// extracted by mini-css-extract-plugin
export default {"videoContainer":"VideoPlayer_videoContainer__Nr0T6","videoPlayer":"VideoPlayer_videoPlayer__jgVhb"};